import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const WalkInClosetIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "WalkInClosetIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.7288 2.9502H2.81034C2.51167 2.9502 2.26953 3.19234 2.26953 3.49101V20.8689C2.26953 21.1675 2.51167 21.4097 2.81034 21.4097C3.10901 21.4097 3.35115 21.1675 3.35115 20.8689V20.3281H21.188V20.8689C21.188 21.1675 21.4301 21.4097 21.7288 21.4097C22.0274 21.4097 22.2696 21.1675 22.2696 20.8689V3.491C22.2696 3.19233 22.0274 2.9502 21.7288 2.9502ZM12.5008 14.884H8.48571V4.03181H12.5008V14.884ZM13.5824 6.23109H16.8246V7.6295L14.8198 9.63429C14.4802 9.97385 14.7208 10.5575 15.2021 10.5575H19.5286C20.0089 10.5575 20.2513 9.97461 19.911 9.63429L17.9062 7.6295V6.23109H21.188V14.884H13.5824V6.23109ZM17.3654 8.6183L18.223 9.47592H16.5078L17.3654 8.6183ZM21.188 5.14948H13.5824V4.03182H21.188V5.14948ZM7.4041 4.03182V14.884H3.35114V4.03181L7.4041 4.03182ZM3.35114 15.9656H12.5008V19.2465H3.35114V15.9656ZM13.5824 19.2465V15.9656H21.188V19.2465H13.5824Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.02649 17.0469H6.85966C6.56099 17.0469 6.31885 17.289 6.31885 17.5877C6.31885 17.8863 6.56099 18.1285 6.85966 18.1285H9.02649C9.32516 18.1285 9.5673 17.8863 9.5673 17.5877C9.5673 17.289 9.32516 17.0469 9.02649 17.0469Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.4496 17.0469H16.2864C15.9877 17.0469 15.7456 17.289 15.7456 17.5877C15.7456 17.8863 15.9877 18.1285 16.2864 18.1285H18.4496C18.7483 18.1285 18.9904 17.8863 18.9904 17.5877C18.9904 17.289 18.7483 17.0469 18.4496 17.0469Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.65067 10.5572C9.94936 10.5572 10.1915 10.3151 10.1915 10.0164C10.1915 9.7177 9.94936 9.47558 9.65067 9.47558C9.35199 9.47558 9.10986 9.7177 9.10986 10.0164C9.10986 10.3151 9.35199 10.5572 9.65067 10.5572Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.32059 10.5572C6.61928 10.5572 6.8614 10.3151 6.8614 10.0164C6.8614 9.7177 6.61928 9.47558 6.32059 9.47558C6.02191 9.47558 5.77979 9.7177 5.77979 10.0164C5.77979 10.3151 6.02191 10.5572 6.32059 10.5572Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default WalkInClosetIcon;
